import { generateActivityFilters } from '../../utils';

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const FILTERS_TO_TRANSFORM__UPPERCASE = ['products', 'eventTypes', 'objectTypes'];
const KEYS_TO_TRANSFROM = new Map([['actors', 'accountIds']]);
export const generateActivityFiltersV2 = (filters = {}) => generateActivityFilters(filters, (originalkey, originalFilter) => {
  const filter = Array.isArray(originalFilter) && FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map(f => f.toUpperCase()) : originalFilter;
  const key = KEYS_TO_TRANSFROM.has(originalkey) ? KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
  return {
    [key]: filter
  };
});